import countries from 'i18n-iso-countries'
import { TLocale } from './machine/i18n/Locale'

// this is needed when you want to access countries in the browser
export const loadCountriesLocale = async (locale: TLocale): Promise<void> => {
  if (!countries.getSupportedLanguages().includes(locale)) {
    throw new Error(`Locale ${locale} not supported`)
  }

  if (countries.langs().includes(locale)) {
    return
  }

  const data = await import(`i18n-iso-countries/langs/${locale}.json`)
  // JSON dynamic imports often wrap the data in `default`
  countries.registerLocale(data)
}

export const getCountries = (locale: TLocale): Record<string, string> =>
  countries.getNames(locale, { select: 'official' })

export const getCountryName = (locale: TLocale, countryCode: string) =>
  countries.getName(countryCode, locale)

// export const getCountryCode = (countryName?: string) =>
//   countryName !== undefined
//     ? countries.getAlpha2Code(countryName, 'en')
//     : undefined

// let euCountries: string[] = []

// export const euCountryCodes = [
//   'AT', // Austria
//   'BE', // Belgium
//   'BG', // Bulgaria
//   'CY', // Cyprus
//   'CZ', // Czech Republic
//   'DE', // Germany
//   'DK', // Denmark
//   'EE', // Estonia
//   'ES', // Spain
//   'FI', // Finland
//   'FR', // France
//   'GR', // Greece
//   'HR', // Croatia
//   'HU', // Hungary
//   'IE', // Ireland
//   'IT', // Italy
//   'LT', // Lithuania
//   'LU', // Luxembourg
//   'LV', // Latvia
//   'MT', // Malta
//   'NL', // Netherlands
//   'PL', // Poland
//   'PT', // Portugal
//   'RO', // Romania
//   'SE', // Sweden
//   'SI', // Slovenia
//   'SK', // Slovakia
// ]

// export const getEuCountries = (locale: TLocale) => {
//   // we want to generate the list of EU country names, so we guarantee a consistent notation
//   if (euCountries.length === 0) {
//     euCountries = euCountryCodes
//       .map((code) => getCountryName(locale, code))
//       .filter((s): s is string => !!s)
//   }

//   return euCountries
// }
